/* ============================================================
   MIRMEDIC · Demo de contenido de la plataforma
   Cárgalo con defer: se arranca solo cuando el DOM está listo.
   ============================================================ */

/* ---------- Funciones globales del resumen (las usan los onclick del HTML) ---------- */
function mirmedic_updateProgress(block){
  var cards = block.querySelectorAll('.mm-recall-card');
  var total = cards.length;
  var open = block.querySelectorAll('.mm-recall-card.mm-open').length;
  var fill = block.querySelector('.mirmedic-recall-fill');
  var text = block.querySelector('.mirmedic-recall-text');
  var pct = total ? Math.round((open/total)*100) : 0;
  if(fill){ fill.style.width = pct + '%'; }
  if(text){
    text.textContent = (total > 0 && open >= total)
      ? '¡Todas descubiertas! 🎉 (' + open + '/' + total + ')'
      : open + '/' + total + ' cajitas descubiertas';
  }
}
function mirmedic_toggleCard(btn){
  var card = btn.closest('.mm-recall-card');
  var open = card.classList.toggle('mm-open');
  var chevron = btn.querySelector('.mm-recall-chevron');
  if(chevron){ chevron.textContent = open ? '−' : '＋'; }
  btn.setAttribute('aria-expanded', open ? 'true' : 'false');
  mirmedic_updateProgress(btn.closest('.mm-block'));
}
function mirmedic_toggleAll(btn, reveal){
  var block = btn.closest('.mm-block');
  var cards = block.querySelectorAll('.mm-recall-card');
  for(var i=0; i<cards.length; i++){
    var card = cards[i];
    var chevron = card.querySelector('.mm-recall-chevron');
    var head = card.querySelector('.mm-recall-head');
    if(reveal){
      card.classList.add('mm-open');
      if(chevron){ chevron.textContent = '−'; }
      if(head){ head.setAttribute('aria-expanded','true'); }
    } else {
      card.classList.remove('mm-open');
      if(chevron){ chevron.textContent = '＋'; }
      if(head){ head.setAttribute('aria-expanded','false'); }
    }
  }
  mirmedic_updateProgress(block);
}

(function(){
  function mirmedicDemoArrancar(){
    /* Progreso inicial de las cajitas del resumen */
    var bloqueResumen = document.querySelector('#mmDemo .mm-block');
    if(bloqueResumen){ mirmedic_updateProgress(bloqueResumen); }

/* ===================== CLAVES MIR ===================== */
(function(){
  var mmAssocItems = [
    {clue1:"Amenorrea primaria con fenotipo femenino normal", clue2:"agenesia total o parcial de la vagina", dx:"Síndrome de Rokitansky", note:"Se debe a un fallo en el desarrollo de las estructuras müllerianas; los ovarios y el fenotipo externo son normales."},
    {clue1:"Cociente LH/FSH mayor de 2", clue2:"con hiperandrogenismo y resistencia a la insulina", dx:"Síndrome de ovario poliquístico", note:"El cociente LH/FSH elevado es muy típico, aunque no forma parte de los criterios diagnósticos oficiales."},
    {clue1:"Úlcera genital indolora", clue2:"con una adenopatía igualmente indolora", dx:"Sífilis primaria (chancro)", note:"El comportamiento es justo el opuesto al herpes genital, donde tanto la úlcera como la adenopatía duelen."},
    {clue1:"Úlcera genital que no duele", clue2:"pero con adenopatías múltiples y dolorosas", dx:"Linfogranuloma venéreo", note:"Una combinación intermedia entre la sífilis (todo indoloro) y el herpes (todo doloroso)."},
    {clue1:"Úlceras y vesículas genitales dolorosas", clue2:"con adenopatías dolorosas de un solo lado", dx:"Herpes genital", note:"Aquí tanto la lesión como el ganglio duelen, justo al contrario que en la sífilis primaria."},
    {clue1:"Dismenorrea y dispareunia", clue2:"junto con dificultad para quedarse embarazada", dx:"Endometriosis", note:"Es de las pocas causas de dispareunia que aparecen en el temario, así que esa pista suele ser determinante."},
    {clue1:"Aumento del sangrado menstrual", clue2:"con sensación de presión en la vejiga", dx:"Mioma uterino", note:"Es el tumor genital más frecuente; la mayoría son asintomáticos y no necesitan tratamiento."},
    {clue1:"Mujer no fumadora y obesa", clue2:"con sangrado tras la menopausia", dx:"Cáncer de endometrio", note:"El perfil de riesgo es casi opuesto al del cáncer de cérvix: aquí pesan más la obesidad y el exceso de estrógenos."},
    {clue1:"Mujer fumadora con relaciones sexuales de riesgo", clue2:"con sangrado descrito como 'en agua de lavar carne'", dx:"Cáncer de cérvix", note:"Detrás está casi siempre el virus del papiloma humano como factor causal."},
    {clue1:"Dolor mamario bilateral que aparece antes de la regla", clue2:"sin adenopatías axilares", dx:"Mastopatía fibroquística", note:"Ese patrón de dolor ligado al ciclo es justo lo que la distingue del resto de tumores benignos de mama."},
    {clue1:"Mujer joven con un bulto liso y móvil en el cuadrante superoexterno", clue2:"sin adenopatías", dx:"Fibroadenoma", note:"Es benigno y relativamente frecuente en mujeres jóvenes; no suele doler."},
    {clue1:"Cáncer de mama con HER2 mutado (sobreexpresado)", clue2:"buscas el tratamiento dirigido específico", dx:"Trastuzumab (o pertuzumab)", note:"El HER2 mutado hace que el tumor crezca más rápido y responda peor a la quimioterapia clásica, de ahí la necesidad de una terapia dirigida."},
    {clue1:"Cáncer de mama localizado, sin adenopatías, tratado con tumorectomía", clue2:"frente al mismo caso tratado con mastectomía completa", dx:"Solo la tumorectomía necesita radioterapia complementaria", note:"La mastectomía completa, al retirar toda la mama, exime de la radioterapia posterior en estos casos localizados."},
    {clue1:"Cáncer de mama triple negativo", clue2:"tratado con cirugía conservadora", dx:"Radioterapia y quimioterapia adyuvante, siempre", note:"A diferencia del cáncer hormonal, en el triple negativo (peor pronóstico) la adyuvancia no se puede evitar."},
    {clue1:"PAPP-A descendida", clue2:"con bHCG elevada en el primer trimestre", dx:"Síndrome de Down", note:"En el tercer trimestre, a estos dos marcadores se suma también el descenso del estradiol."},
    {clue1:"Embarazo reciente", clue2:"con metrorragia y dolor abdominal", dx:"Embarazo ectópico", note:"La combinación de sangrado y dolor abdominal en un embarazo incipiente obliga a descartarlo primero."},
    {clue1:"bHCG extremadamente elevada", clue2:"con un útero más grande de lo que correspondería por las semanas de amenorrea", dx:"Mola hidatídica", note:"Es típico que la bHCG supere los 100.000; la histología muestra degeneración hidrópica de las vellosidades."},
    {clue1:"En el tercer trimestre, hemorragia indolora con sangre roja", clue2:"sin contracciones ni dolor abdominal asociado", dx:"Placenta previa", note:"Se diferencia claramente del desprendimiento de placenta, que además de sangrado, produce mucho dolor."},
    {clue1:"En el tercer trimestre, hemorragia muy dolorosa", clue2:"con sangre de color oscuro", dx:"Desprendimiento de placenta", note:"El dolor intenso es la clave que lo separa de la placenta previa."},
    {clue1:"Hemorragia abundante", clue2:"que coincide justo con la rotura de la bolsa", dx:"Rotura de vasa previa", note:"El momento (justo al romperse la bolsa) es la pista más característica."},
    {clue1:"Antecedente de cesárea previa", clue2:"y ahora se palpan partes fetales directamente a través del abdomen", dx:"Rotura uterina", note:"Es una urgencia obstétrica grave que requiere extracción fetal inmediata."},
    {clue1:"Antecedente de contacto con gatos o de comer carne poco hecha", clue2:"con calcificaciones cerebrales dispersas en el recién nacido", dx:"Toxoplasmosis congénita", note:"El diagnóstico se confirma habitualmente mediante la elevación de IgG."},
    {clue1:"Hepatoesplenomegalia en el recién nacido", clue2:"con calcificaciones cerebrales periventriculares", dx:"Citomegalovirus congénito", note:"Aquí el diagnóstico se prefiere confirmar mediante PCR en líquido amniótico."},
    {clue1:"Ampollas o descamación en las palmas del recién nacido", clue2:"con secreción nasal mucosanguinolenta", dx:"Sífilis congénita", note:"El contagio suele producirse a partir de la semana 14 de gestación, sobre todo si la madre no ha sido tratada."},
    {clue1:"Embarazada de más de 20 semanas", clue2:"que ha tenido contacto con varicela", dx:"Actitud expectante (bajo riesgo)", note:"El riesgo real de defectos congénitos se concentra entre las semanas 12 y 20, y también alrededor del parto — pasada la semana 20, el riesgo es prácticamente nulo."},
    {clue1:"Embarazada con prurito intenso", clue2:"con fosfatasa alcalina elevada y transaminasas normales o solo algo elevadas", dx:"Colestasis intrahepática gestacional", note:"Si las transaminasas estuvieran claramente elevadas, pensarías mejor en un hígado graso agudo del embarazo."},
    {clue1:"Enfermedad inflamatoria pélvica", clue2:"en una mujer portadora de DIU", dx:"Actinomyces israelii", note:"Es la excepción a la regla: normalmente pensarías en clamidia o gonococo, pero el DIU cambia la sospecha."},
    {clue1:"Mujer posmenopáusica con pápulas blancas en la vulva", clue2:"que producen picor", dx:"Liquen escleroso", note:"Se relaciona con el déficit de estrógenos propio de la menopausia; el tratamiento inicial son los corticoides tópicos."},
    {clue1:"Cáncer de cérvix menor de 4 cm, sin invasión de los parametrios", clue2:"frente al mismo tumor pero mayor de 4 cm o con invasión de parametrios", dx:"El primero se trata con cirugía; el segundo con quimio y radioterapia", note:"El límite de los 4 cm (o la invasión parametrial) marca cuándo la cirugía deja de tener intención curativa."},
    {clue1:"Distensión abdominal, dolor abdominal y metrorragia", clue2:"en una mujer, buscando el tumor ginecológico responsable", dx:"Cáncer de ovario", note:"Su pronóstico es malo precisamente porque esta tríada suele aparecer ya en fases avanzadas."},
    {clue1:"Cáncer de mama con ganglios positivos", clue2:"o con algún factor de mal pronóstico (tamaño >2cm, edad <35 años, HER2 positivo)", dx:"Quimioterapia neo o adyuvante", note:"Si no se cumple ninguna de estas condiciones, se puede recurrir a plataformas genéticas para decidir si la quimioterapia realmente aporta beneficio."},
    {clue1:"Embarazada en el tercer trimestre con insuficiencia hepática", clue2:"y encefalopatía", dx:"Hígado graso agudo del embarazo", note:"A diferencia de la colestasis gestacional, aquí el cuadro es mucho más grave y obliga a finalizar la gestación."},
    {clue1:"Embarazada con un bultito mucoso en la encía", clue2:"aparecido durante el primer trimestre", dx:"Épulis del embarazo", note:"Se debe al aumento de estrógenos y suele desaparecer solo tras el parto."},
    {clue1:"Hipertensión en el embarazo antes de la semana 20", clue2:"detectada en una gestación única", dx:"Hipertensión crónica", note:"Salvo en embarazos múltiples, la preeclampsia no se diagnostica antes de las 20 semanas."},
    {clue1:"Hipertensión después de la semana 20 de embarazo", clue2:"acompañada de proteinuria", dx:"Preeclampsia", note:"Si no hay proteinuria ni otra clínica acompañante, hablaríamos en cambio de hipertensión inducida por el embarazo."},
    {clue1:"Presentación fetal cefálica de frente, o de cara mentoposterior", clue2:"buscas la vía de parto indicada", dx:"Cesárea", note:"Son las únicas dos variedades de presentación cefálica en las que la cesárea es obligatoria; el resto puede intentarse por vía vaginal."},
    {clue1:"Secreción hemática por el pezón, de un solo lado", clue2:"sin ningún nódulo palpable", dx:"Papiloma intraductal", note:"Es la causa más frecuente de telorrea hemática cuando no hay masa asociada."},
    {clue1:"Sensación de pesadez en la parte baja del abdomen", clue2:"con antecedente de varios abortos tardíos", dx:"Incompetencia cervical", note:"El tratamiento de elección es el cerclaje cervical."},
    {clue1:"Mujer embarazada en tratamiento con estatinas", clue2:"buscas la categoría de riesgo del fármaco", dx:"Categoría X (contraindicadas, teratogenia probada)", note:"El resto de hipolipemiantes se consideran categoría C, algo menos desaconsejados."},
    {clue1:"De las dos inmunoglobulinas principales del embarazo", clue2:"buscas cuál atraviesa la barrera placentaria", dx:"IgG", note:"La IgM, en cambio, no cruza la placenta — por eso la vacunación materna busca generar IgG que proteja al bebé tras nacer."},
    {clue1:"Primer trimestre del embarazo", clue2:"buscas el marcador ecográfico más importante del cribado", dx:"Translucencia nucal", note:"Su aumento se relaciona con trisomías clásicas, como la del cromosoma 21."},
    {clue1:"Mujer menor de 35 años con un bulto en la mama", clue2:"buscas la prueba de imagen inicial", dx:"Ecografía mamaria", note:"A partir de los 35 años se prefiere empezar directamente por la mamografía; con mutación BRCA o prótesis mamaria, la prueba de elección pasa a ser la resonancia magnética."},
    {clue1:"Cáncer de mama sin receptores hormonales", clue2:"y con HER2 negativo", dx:"Cáncer de mama basal-like (triple negativo)", note:"Es el subtipo de peor pronóstico dentro del cáncer de mama."},
    {clue1:"Cáncer de cérvix ya metastásico", clue2:"buscas el tratamiento de primera línea", dx:"Quimioterapia con platino más bevacizumab", note:"El bevacizumab, al ser antiangiogénico, puede favorecer el sangrado, la hipertensión y dificultar la cicatrización."}
  ];
  var mmAssocPool = [];
  var mmAssocStatusArr = [];
  var mmAssocMode = 'deck';
  var mmAssocQueue = [];
  var mmAssocStreak = 0;
  var mmAssocFlipped = false;
  var mmAssocJustMastered = false;
  function mirmedic_assocShow(el, value){ el.style.setProperty('display', value, 'important'); }
  function mirmedic_assocBuildPool(){
    mmAssocPool = mmAssocItems.slice();
    mmAssocStatusArr = mmAssocPool.map(function(){ return 'pending'; });
    mmAssocStreak = 0;
    mmAssocJustMastered = false;
    mirmedic_assocEnterMode('deck');
  }
  function mirmedic_assocEnterMode(mode){
    mmAssocMode = mode;
    mmAssocQueue = [];
    mmAssocStatusArr.forEach(function(s, i){
      if(mode === 'deck' && s === 'pending') mmAssocQueue.push(i);
      if(mode === 'folder-review' && s === 'review') mmAssocQueue.push(i);
      if(mode === 'folder-know' && s === 'know') mmAssocQueue.push(i);
    });
    mirmedic_assocRenderModeLabel();
    mirmedic_assocRenderCard();
    mirmedic_assocUpdateStats();
  }
  function mirmedic_assocRenderModeLabel(){
    var label = document.getElementById('mmAssocModeLabel');
    var back = document.getElementById('mmAssocBackToDeck');
    if(mmAssocMode === 'deck'){ label.textContent = 'Viendo el mazo'; back.style.display = 'none'; }
    else if(mmAssocMode === 'folder-review'){ label.textContent = 'Repasando: A repasar'; back.style.display = 'inline'; }
    else { label.textContent = 'Repasando: Lo sé'; back.style.display = 'inline'; }
    document.getElementById('mmAssocFolderReview').classList.toggle('is-active', mmAssocMode === 'folder-review');
    document.getElementById('mmAssocFolderKnow').classList.toggle('is-active', mmAssocMode === 'folder-know');
  }
  function mirmedic_assocRenderCard(){
    var cardEl = document.getElementById('mmAssocCard');
    var actionsEl = document.getElementById('mmAssocActions');
    var emptyEl = document.getElementById('mmAssocEmpty');
    if(mmAssocQueue.length === 0){
      mirmedic_assocShow(cardEl, 'none');
      mirmedic_assocShow(actionsEl, 'none');
      mirmedic_assocShow(emptyEl, 'flex');
      mirmedic_assocRenderEmptyState();
      return;
    }
    mirmedic_assocShow(cardEl, 'block');
    mirmedic_assocShow(actionsEl, 'flex');
    mirmedic_assocShow(emptyEl, 'none');
    var it = mmAssocPool[mmAssocQueue[0]];
    document.getElementById('mmAssocClues').innerHTML = '<li>' + it.clue1 + '</li><li>' + it.clue2 + '</li>';
    document.getElementById('mmAssocDx').textContent = it.dx;
    document.getElementById('mmAssocNote').textContent = it.note;
    mmAssocFlipped = false;
    document.getElementById('mmAssocInner').classList.remove('is-flipped');
    cardEl.classList.remove('is-entering');
    void cardEl.offsetWidth;
    cardEl.classList.add('is-entering');
  }
  function mirmedic_assocRenderEmptyState(){
    var msgEl = document.getElementById('mmAssocEmptyMsg');
    var ctaEl = document.getElementById('mmAssocEmptyCta');
    var emptyEl = document.getElementById('mmAssocEmpty');
    var total = mmAssocPool.length;
    var knowCount = mmAssocStatusArr.filter(function(s){ return s==='know'; }).length;
    var reviewCount = mmAssocStatusArr.filter(function(s){ return s==='review'; }).length;
    if(mmAssocJustMastered){
      emptyEl.classList.add('is-grand');
      msgEl.textContent = '¡Dominas todas las claves de esta asignatura! 🎉';
      ctaEl.style.display = 'none';
      mmAssocJustMastered = false;
      mirmedic_assocGrandConfetti();
      return;
    }
    emptyEl.classList.remove('is-grand');
    if(mmAssocMode === 'deck'){
      if(total === 0){
        msgEl.textContent = 'No hay claves cargadas todavía.';
        ctaEl.style.display = 'none';
      } else if(reviewCount === 0){
        msgEl.textContent = '¡Dominas todas las claves de esta asignatura! 🎉';
        ctaEl.style.display = 'none';
      } else {
        msgEl.textContent = 'Ya has visto todas las claves. Repasa tu carpeta "A repasar" hasta dominarlas.';
        ctaEl.textContent = 'Abrir "A repasar" (' + reviewCount + ')';
        ctaEl.style.display = 'inline-block';
        ctaEl.onclick = function(){ mirmedic_assocEnterMode('folder-review'); };
      }
    } else if(mmAssocMode === 'folder-review'){
      if(reviewCount === 0 && knowCount === 0){
        msgEl.textContent = 'Todavía no tienes claves en esta carpeta. Repasa primero el mazo.';
      } else {
        msgEl.textContent = '¡Carpeta "A repasar" vacía! Has dominado todas las claves de repaso 🎉';
      }
      ctaEl.textContent = '← Volver al mazo';
      ctaEl.style.display = 'inline-block';
      ctaEl.onclick = function(){ mirmedic_assocEnterMode('deck'); };
    } else {
      msgEl.textContent = 'No tienes claves en esta carpeta.';
      ctaEl.textContent = '← Volver al mazo';
      ctaEl.style.display = 'inline-block';
      ctaEl.onclick = function(){ mirmedic_assocEnterMode('deck'); };
    }
  }
  function mirmedic_assocUpdateStats(){
    var total = mmAssocPool.length;
    var knowCount = mmAssocStatusArr.filter(function(s){ return s==='know'; }).length;
    var reviewCount = mmAssocStatusArr.filter(function(s){ return s==='review'; }).length;
    document.getElementById('mmAssocBar').style.width = (total ? Math.round(knowCount/total*100) : 0) + '%';
    document.getElementById('mmAssocCount').textContent = knowCount + ' / ' + total + ' dominadas';
    document.getElementById('mmAssocStreak').textContent = mmAssocStreak;
    document.getElementById('mmAssocKnowCount').textContent = knowCount;
    document.getElementById('mmAssocReviewCount').textContent = reviewCount;
  }
  function mirmedic_assocFlyToFolder(status){
    var card = document.getElementById('mmAssocCard');
    var target = status === 'know' ? document.getElementById('mmAssocFolderKnow') : document.getElementById('mmAssocFolderReview');
    var widget = document.getElementById('mmAssocWidget');
    var cardRect = card.getBoundingClientRect();
    var targetRect = target.getBoundingClientRect();
    var widgetRect = widget.getBoundingClientRect();
    var clone = document.createElement('div');
    clone.className = 'mm-assoc-flying-card ' + (status === 'know' ? 'mm-assoc-flying-know' : 'mm-assoc-flying-review');
    clone.style.left = (cardRect.left - widgetRect.left) + 'px';
    clone.style.top = (cardRect.top - widgetRect.top) + 'px';
    clone.style.width = cardRect.width + 'px';
    clone.style.height = cardRect.height + 'px';
    var dx = (targetRect.left + targetRect.width/2) - (cardRect.left + cardRect.width/2);
    var dy = (targetRect.top + targetRect.height/2) - (cardRect.top + cardRect.height/2);
    clone.style.setProperty('--fly-dx', dx + 'px');
    clone.style.setProperty('--fly-dy', dy + 'px');
    widget.appendChild(clone);
    target.classList.add('is-bump');
    setTimeout(function(){ target.classList.remove('is-bump'); }, 320);
    setTimeout(function(){ if(clone.parentNode) clone.parentNode.removeChild(clone); }, 480);
    if(status === 'know'){
      setTimeout(function(){ mirmedic_assocConfettiAt(target); }, 380);
    }
  }
  function mirmedic_assocConfettiAt(targetEl){
    var widget = document.getElementById('mmAssocWidget');
    var widgetRect = widget.getBoundingClientRect();
    var targetRect = targetEl.getBoundingClientRect();
    var originX = targetRect.left - widgetRect.left + targetRect.width/2;
    var originY = targetRect.top - widgetRect.top + targetRect.height/2;
    var colors = ['#3B9E63','#306086','#E0A845','#D4537E'];
    var frag = document.createDocumentFragment();
    var pieces = [];
    for(var i=0;i<8;i++){
      var p = document.createElement('span');
      p.className = 'mm-assoc-confetti-piece';
      var angle = Math.random()*Math.PI*2;
      var dist = 20 + Math.random()*20;
      p.style.left = originX + 'px';
      p.style.top = originY + 'px';
      p.style.background = colors[i % colors.length];
      p.style.setProperty('--dx', (Math.cos(angle)*dist)+'px');
      p.style.setProperty('--dy', (Math.sin(angle)*dist - 10)+'px');
      p.style.setProperty('--rot', (Math.random()*360)+'deg');
      frag.appendChild(p);
      pieces.push(p);
    }
    widget.appendChild(frag);
    setTimeout(function(){ pieces.forEach(function(p){ if(p.parentNode) p.parentNode.removeChild(p); }); }, 520);
  }
  function mirmedic_assocGrandConfetti(){
    var widget = document.getElementById('mmAssocWidget');
    var widgetRect = widget.getBoundingClientRect();
    var colors = ['#3B9E63','#306086','#E0A845','#D4537E'];
    var frag = document.createDocumentFragment();
    var pieces = [];
    var count = 34;
    for(var i=0;i<count;i++){
      var p = document.createElement('span');
      p.className = 'mm-assoc-confetti-piece mm-assoc-confetti-big';
      var originX = 10 + Math.random()*Math.max(1, widgetRect.width-20);
      p.style.left = originX + 'px';
      p.style.top = '-10px';
      p.style.background = colors[i % colors.length];
      p.style.setProperty('--dx', ((Math.random()-0.5)*70)+'px');
      p.style.setProperty('--dy', (140 + Math.random()*90)+'px');
      p.style.setProperty('--rot', (Math.random()*360)+'deg');
      p.style.animationDelay = (Math.random()*0.18) + 's';
      frag.appendChild(p);
      pieces.push(p);
    }
    widget.appendChild(frag);
    setTimeout(function(){ pieces.forEach(function(p){ if(p.parentNode) p.parentNode.removeChild(p); }); }, 1100);
  }
  function mirmedic_assocMark(newStatus){
    if(mmAssocQueue.length === 0) return;
    var idx = mmAssocQueue[0];
    mirmedic_assocFlyToFolder(newStatus);
    mmAssocStatusArr[idx] = newStatus;
    mmAssocStreak = (newStatus === 'know') ? mmAssocStreak + 1 : 0;
    var keepInQueue = (mmAssocMode === 'folder-review' && newStatus === 'review') ||
                       (mmAssocMode === 'folder-know' && newStatus === 'know');
    mmAssocQueue.shift();
    if(keepInQueue) mmAssocQueue.push(idx);
    mirmedic_assocUpdateStats();
    var knowCountNow = mmAssocStatusArr.filter(function(s){ return s==='know'; }).length;
    mmAssocJustMastered = (knowCountNow === mmAssocPool.length && mmAssocPool.length > 0);
    setTimeout(function(){
      mirmedic_assocRenderCard();
      mirmedic_assocUpdateStats();
    }, 260);
  }
  document.getElementById('mmAssocCard').addEventListener('click', function(){
    mmAssocFlipped = !mmAssocFlipped;
    document.getElementById('mmAssocInner').classList.toggle('is-flipped', mmAssocFlipped);
  });
  document.getElementById('mmAssocKnow').addEventListener('click', function(e){ e.stopPropagation(); mirmedic_assocMark('know'); });
  document.getElementById('mmAssocReview').addEventListener('click', function(e){ e.stopPropagation(); mirmedic_assocMark('review'); });
  document.getElementById('mmAssocFolderReview').addEventListener('click', function(){ mirmedic_assocEnterMode('folder-review'); });
  document.getElementById('mmAssocFolderKnow').addEventListener('click', function(){ mirmedic_assocEnterMode('folder-know'); });
  document.getElementById('mmAssocBackToDeck').addEventListener('click', function(){ mirmedic_assocEnterMode('deck'); });
  mirmedic_assocBuildPool();
})();

/* ===================== ACTIVIDAD INTERACTIVA ===================== */
(function(){
  var root = document.getElementById('mmw-ciclo');
  if(!root || root.getAttribute('data-mmw-ready') === '1') return;
  root.setAttribute('data-mmw-ready','1');
  /* =========================================================================
     1) DATOS — todo el contenido del widget vive aquí.
     ========================================================================= */
  var N_ESTACIONES = 5;
  var DATA = {
    /* --- ESTACIÓN 1: ráfaga verdadero / falso --- */
    est1: {
      chip:'Estación 1 de 5 · Calentamiento',
      titulo:'⚡ Verdadero o falso: el eje hormonal',
      intro:'Seis afirmaciones para calentar motores. Si dudas más de tres segundos, ese dato necesita repaso.',
      items:[
        { t:'Los pulsos rápidos de GnRH estimulan preferentemente la secreción de LH.',
          v:true,
          fb:'Correcto: pulsos rápidos de GnRH → LH; pulsos lentos → FSH.' },
        { t:'La administración continua (no pulsátil) de GnRH estimula la LH y la FSH, por lo que se usa para inducir la ovulación.',
          v:false,
          fb:'Falso: la administración continua <strong>inhibe</strong> la LH y la FSH, generando hipoestrogenismo; por eso se usa en el tratamiento de la <strong>endometriosis</strong>, no para inducir la ovulación.' },
        { t:'Las células de la teca, estimuladas por LH, producen andrógenos que después son aromatizados a estrógenos por la granulosa.',
          v:true,
          fb:'Correcto: es la teoría de las dos células.' },
        { t:'El aumento de estrógenos en la fase proliferativa ejerce una retroalimentación positiva sobre la FSH, permitiendo que maduren varios folículos a la vez.',
          v:false,
          fb:'Falso: es una retroalimentación <strong>negativa</strong> sobre la FSH, lo que permite que sobreviva un único folículo dominante.' },
        { t:'La progesterona secretada por el cuerpo lúteo en la fase secretora provoca un aumento de la temperatura basal.',
          v:true,
          fb:'Correcto.' },
        { t:'La estrona es el estrógeno predominante en la edad fértil, mientras que el estradiol predomina en el climaterio.',
          v:false,
          fb:'Falso: es al revés. El <strong>estradiol</strong> predomina en la edad fértil; la <strong>estrona</strong> predomina en el climaterio y en el síndrome de ovario poliquístico.' }
      ]
    },
    /* --- ESTACIÓN 2: emparejar concepto ↔ dato exacto --- */
    est2: {
      chip:'Estación 2 de 5 · Emparejar',
      titulo:'🔑 Cada concepto con su dato exacto',
      intro:'Ocho conceptos del eje hormonal y del ciclo. Cada uno tiene un dato preciso asociado.',
      hint:'Pulsa un concepto y después su dato.',
      pares:[
        { a:'Pulsos rápidos de GnRH', b:'Estimulan preferentemente la secreción de LH', fb:'La frecuencia de los pulsos de GnRH determina qué gonadotropina predomina.' },
        { a:'Pulsos lentos de GnRH', b:'Estimulan preferentemente la secreción de FSH', fb:'A menor frecuencia de pulsos, mayor estímulo relativo sobre la FSH.' },
        { a:'Células de la teca', b:'Estimuladas por LH, producen andrógenos', fb:'Primer paso de la teoría de las dos células.' },
        { a:'Células de la granulosa', b:'Estimuladas por FSH, aromatizan los andrógenos a estrógenos', fb:'Segundo paso: la aromatasa convierte andrógenos en estrógenos.' },
        { a:'Estradiol', b:'Estrógeno principal durante la edad fértil', fb:'Es el estrógeno predominante en la mujer en edad reproductiva.' },
        { a:'Estrona', b:'Predomina en el climaterio y en el síndrome de ovario poliquístico', fb:'Su producción no depende tanto de la función ovárica cíclica.' },
        { a:'Oligomenorrea', b:'Ciclos de más de 45 días y menos de 6 meses, frecuente en el SOP', fb:'Más allá de 6 meses sin regla se considera ya amenorrea.' },
        { a:'Polimenorrea', b:'Ciclos cortos, frecuente en la endometriosis', fb:'Contraste clásico con la oligomenorrea del SOP.' }
      ],
      cierre:'Estos son justo los datos que más se confunden en el examen: la cifra o el sentido exactos son la clave.'
    },
    /* --- ESTACIÓN 3: ordenar secuencia --- */
    est3: {
      chip:'Estación 3 de 5 · Ordenar',
      titulo:'🔢 El orden correcto',
      intro:'Dos secuencias clave: las fases del ciclo y los pasos de la teoría de las dos células.',
      rondas:[
        { pregunta:'¿En qué orden se suceden las fases del ciclo genital femenino?',
          pasos:['Fase menstrual: caen los estrógenos y las prostaglandinas, sube la FSH y se reclutan folículos','Fase proliferativa: suben los estrógenos y se selecciona el folículo dominante','Periovulación: segundo pico de FSH y pico de LH que desencadena la ovulación','Fase secretora: el cuerpo lúteo produce progesterona y prepara el endometrio'],
          explicacion:'El ciclo avanza siempre en este orden: menstrual → proliferativa → periovulación → secretora, y vuelta a empezar si no hay fecundación.' },
        { pregunta:'¿Cuál es la secuencia de la teoría de las dos células, desde el estímulo hormonal hasta el estrógeno final?',
          pasos:['La LH estimula las células de la teca','Las células de la teca producen andrógenos','Los andrógenos pasan a las células de la granulosa','La FSH activa la aromatasa en la granulosa, que convierte los andrógenos en estrógenos'],
          explicacion:'Dos células, dos hormonas: LH → teca → andrógenos; FSH → granulosa → aromatasa → estrógenos.' }
      ]
    },
    /* --- ESTACIÓN 4: clasificar por fase del ciclo --- */
    est4: {
      chip:'Estación 4 de 5 · Clasificar',
      titulo:'🗂️ ¿Qué ocurre en cada fase?',
      intro:'Ocho datos del ciclo. Clasifícalos en la fase a la que pertenecen.',
      hint:'Arrastra cada dato a su fase, o pulsa el dato y después la fase.',
      zonas:[
        { label:'🩸 Menstrual' },
        { label:'📈 Proliferativa' },
        { label:'🌟 Periovulación' },
        { label:'🌙 Secretora' }
      ],
      items:[
        { t:'Caen los estrógenos y las prostaglandinas', z:0, fb:'Menstrual: es el desencadenante de la caída hormonal que da paso a la regla.' },
        { t:'Sube la FSH y se reclutan los folículos', z:0, fb:'Menstrual: el ascenso de FSH recluta la cohorte de folículos de ese ciclo.' },
        { t:'Suben los estrógenos de forma progresiva', z:1, fb:'Proliferativa: el folículo en crecimiento produce cada vez más estrógenos.' },
        { t:'Se selecciona el folículo dominante por retroalimentación negativa sobre la FSH', z:1, fb:'Proliferativa: los estrógenos crecientes frenan la FSH y solo sobrevive un folículo.' },
        { t:'Se produce un segundo pico de FSH que termina de madurar el folículo', z:2, fb:'Periovulación: este segundo pico de FSH precede a la ovulación.' },
        { t:'El pico de LH desencadena la ovulación', z:2, fb:'Periovulación: el pico de LH es el disparador directo de la ovulación.' },
        { t:'El cuerpo lúteo produce progesterona', z:3, fb:'Secretora: el cuerpo lúteo formado tras la ovulación sintetiza progesterona.' },
        { t:'Sin fecundación, se produce la luteólisis y comienza la menstruación', z:3, fb:'Secretora: el fin del cuerpo lúteo cierra el ciclo y da paso a una nueva fase menstrual.' }
      ],
      cierre:'Fíjate en el patrón: cada fase tiene su hormona protagonista y su efecto característico sobre el folículo o el endometrio.'
    },
    /* --- ESTACIÓN 5: caza al impostor --- */
    est5: {
      chip:'Estación 5 de 5 · Caza al impostor',
      titulo:'🕵️ Encuentra la afirmación que no encaja',
      intro:'Dos escenarios con las trampas más frecuentes. En cada uno, tres afirmaciones son correctas y una es un impostor.',
      rondas:[
        { escenario:'Sobre la pulsatilidad de la GnRH, ¿cuál de estas afirmaciones NO es correcta?',
          opts:[
            { t:'Los pulsos rápidos de GnRH estimulan preferentemente la LH', ok:false },
            { t:'Los pulsos lentos de GnRH estimulan preferentemente la FSH', ok:false },
            { t:'La administración continua de GnRH se usa para tratar la endometriosis mediante un estado de hipoestrogenismo', ok:false },
            { t:'La administración continua de GnRH estimula la LH y la FSH de forma sostenida, por lo que induce la ovulación', ok:true,
              fb:'Correcto, ese es el impostor. La administración continua desensibiliza los receptores hipofisarios e inhibe la LH y la FSH; no induce la ovulación, produce hipoestrogenismo terapéutico.' }
          ] },
        { escenario:'Sobre la fase proliferativa y la selección del folículo dominante, ¿cuál de estas afirmaciones NO es correcta?',
          opts:[
            { t:'En la fase proliferativa, el aumento de estrógenos ejerce retroalimentación negativa sobre la FSH', ok:false },
            { t:'Esa retroalimentación negativa es lo que permite que solo un folículo dominante sobreviva', ok:false },
            { t:'En la fase secretora, la progesterona del cuerpo lúteo aumenta la temperatura basal', ok:false },
            { t:'El aumento de estrógenos en la fase proliferativa estimula la FSH, permitiendo que maduren varios folículos a la vez', ok:true,
              fb:'Correcto, ese es el impostor. Es justo lo contrario: los estrógenos crecientes inhiben la FSH (retroalimentación negativa), por lo que solo madura un folículo dominante.' }
          ] }
      ]
    },
    /* --- Resumen final --- */
    resumen:[
      '<strong>GnRH pulsátil</strong>: pulsos <strong>rápidos → LH</strong>; pulsos <strong>lentos → FSH</strong>. La <strong>administración continua</strong> inhibe LH y FSH (hipoestrogenismo), y se usa en la <strong>endometriosis</strong>.',
      '<strong>Teoría de las dos células</strong>: <strong>teca</strong> (LH → andrógenos) + <strong>granulosa</strong> (FSH → aromatasa → estrógenos).',
      '<strong>Fase menstrual</strong> (días 1-4): caen estrógenos/prostaglandinas, sube la FSH y se reclutan folículos.',
      '<strong>Fase proliferativa</strong>: suben los estrógenos → retroalimentación <strong>negativa</strong> sobre la FSH → selección del folículo dominante.',
      '<strong>Periovulación</strong>: segundo pico de FSH madura el folículo; el <strong>pico de LH desencadena la ovulación</strong>.',
      '<strong>Fase secretora</strong>: el cuerpo lúteo produce progesterona (↑temperatura basal); sin fecundación, luteólisis → menstruación.',
      '<strong>Estradiol</strong>: predomina en la edad fértil. <strong>Estrona</strong>: predomina en el climaterio y en el síndrome de ovario poliquístico.',
      '<strong>Oligomenorrea</strong>: ciclos &gt;45 días y &lt;6 meses (SOP). <strong>Polimenorrea</strong>: ciclos cortos (endometriosis). Ciclo normal: 21-35 días, ovulación en el día 14.'
    ]
  };
  /* =========================================================================
     2) ESTADO
     ========================================================================= */
  var TOTAL = DATA.est1.items.length + DATA.est2.pares.length + DATA.est3.rondas.length +
              DATA.est4.items.length + DATA.est5.rondas.length;
  var state = {
    vista:'portada',
    est:0,
    paso:0,
    hechos:0,
    puntos:0,
    racha:0,
    mejorRacha:0,
    limpios:0,
    fallos:0,
    falladas:[],
    repaso:false,
    repasoIdx:0,
    repasoLista:[]
  };
  /* =========================================================================
     3) UTILIDADES
     ========================================================================= */
  function q(sel){ return root.querySelector('[data-mmw="'+sel+'"]'); }
  var elContent = q('content'), elCover = q('cover'), elEnd = q('end'),
      elStage = q('stage'), elBadge = q('badge'), elHud = q('hud'),
      elNeedle = q('needle'), elReloj = q('reloj'), elBar = q('barFill'), elBarLbl = q('barLabel'),
      elScore = q('score'), elStreak = q('streak'), elConfetti = q('confetti'),
      elDesajuste = q('desajuste'), elDesajusteFill = q('desajusteFill');
  function barajar(arr){
    var a = arr.slice(), i, j, t;
    for(i=a.length-1;i>0;i--){ j=Math.floor(Math.random()*(i+1)); t=a[i]; a[i]=a[j]; a[j]=t; }
    return a;
  }
  function bump(el){
    if(!el) return;
    el.classList.remove('mmw-bump');
    void el.offsetWidth;
    el.classList.add('mmw-bump');
  }
  function sumarPuntos(n){
    state.puntos += n;
    if(elScore) elScore.textContent = state.puntos;
    bump(q('scoreChip'));
  }
  function acierto(primera){
    if(primera){
      state.limpios++;
      state.racha++;
      if(state.racha > state.mejorRacha) state.mejorRacha = state.racha;
      sumarPuntos(10);
    } else {
      sumarPuntos(4);
    }
    if(elStreak) elStreak.textContent = state.racha;
    pintarRiesgo();
  }
  function fallo(pregunta){
    state.fallos++;
    state.racha = 0;
    if(elStreak) elStreak.textContent = '0';
    if(pregunta){
      var ya=false;
      for(var i=0;i<state.falladas.length;i++){ if(state.falladas[i].id===pregunta.id) ya=true; }
      if(!ya) state.falladas.push(pregunta);
    }
    pintarRiesgo();
  }
  /* Aguja del medidor + reloj de fases + barra de desajuste */
  function pintarRiesgo(){
    var vistos = state.limpios + state.fallos;
    var riesgo = vistos ? state.fallos / Math.max(8, vistos) : 0;
    if(riesgo > 1) riesgo = 1;
    var deg = -72 + 144 * riesgo;
    if(elNeedle) elNeedle.setAttribute('transform','rotate('+deg.toFixed(1)+' 75 105)');
    var degReloj = -15 + 30 * riesgo;
    if(elReloj) elReloj.setAttribute('transform','rotate('+degReloj.toFixed(1)+' 214 90)');
    if(elDesajuste){ elDesajuste.textContent = Math.round(2 + riesgo*7) + '/10'; }
    if(elDesajusteFill){
      var w = 8 + riesgo*38;
      elDesajusteFill.setAttribute('width', w.toFixed(1));
      var color = riesgo < 0.16 ? '#3fa96a' : (riesgo < 0.36 ? '#dfa14a' : '#c9604f');
      elDesajusteFill.setAttribute('fill', color);
    }
    elStage.classList.remove('mmw-mood-warn','mmw-mood-bad','mmw-mood-good');
    if(!vistos) return;
    if(riesgo < 0.16){
      elStage.classList.add('mmw-mood-good');
      setBadge('🟢 Eje claro');
    } else if(riesgo < 0.36){
      elStage.classList.add('mmw-mood-warn');
      setBadge('🟠 Se te escapa algo');
    } else {
      elStage.classList.add('mmw-mood-bad');
      setBadge('🔴 Fases confundidas');
    }
  }
  function setBadge(txt){ if(elBadge) elBadge.textContent = txt; }
  function progreso(){
    var pct = TOTAL ? Math.round((state.hechos/TOTAL)*100) : 0;
    if(elBar) elBar.style.width = pct+'%';
    if(elBarLbl) elBarLbl.textContent = state.repaso
      ? 'Repasando fallos · '+(state.repasoIdx+1)+' de '+state.repasoLista.length
      : 'Estación '+Math.min(state.est+1,N_ESTACIONES)+' de '+N_ESTACIONES+' · '+pct+'%';
  }
  /* =========================================================================
     4) BLOQUES DE HTML REUTILIZABLES
     ========================================================================= */
  function cabecera(chip, titulo, intro){
    var h = '<span class="mmw-chip">'+chip+'</span>';
    if(titulo) h += '<h3 class="mmw-h3">'+titulo+'</h3>';
    if(intro) h += '<p class="mmw-intro">'+intro+'</p>';
    return h;
  }
  function fbBox(){
    return '<div class="mmw-fb" data-mmw="fb" aria-live="polite"></div>';
  }
  function acciones(){
    return '<div class="mmw-actions" data-mmw="acts"></div>';
  }
  function pintarFb(ok, titulo, texto, perla){
    var fb = q('fb');
    if(!fb) return;
    fb.className = 'mmw-fb mmw-show ' + (ok ? 'mmw-ok' : 'mmw-bad');
    fb.innerHTML = '<p class="mmw-fb-t">'+(ok?'✅ ':'❌ ')+titulo+'</p><p>'+texto+'</p>' +
      (perla ? '<div class="mmw-pearl">💡 <strong>Perla MIR:</strong> '+perla+'</div>' : '');
  }
  function botonSiguiente(txt){
    var acts = q('acts');
    if(acts) acts.innerHTML = '<button type="button" class="mmw-btn mmw-pulsebtn" data-act="next">'+txt+'</button>';
  }
  /* =========================================================================
     5) RENDER DE CADA MECÁNICA
     ========================================================================= */
  /* --- Portada de estación --- */
  var PORTADAS = [
    { chip:DATA.est1.chip, t:DATA.est1.titulo, p:DATA.est1.intro, cta:'Empezar la ráfaga →' },
    { chip:DATA.est2.chip, t:DATA.est2.titulo, p:DATA.est2.intro, cta:'Buscar el dato exacto →' },
    { chip:DATA.est3.chip, t:DATA.est3.titulo, p:DATA.est3.intro, cta:'Ordenar la secuencia →' },
    { chip:DATA.est4.chip, t:DATA.est4.titulo, p:DATA.est4.intro, cta:'Clasificar por fase →' },
    { chip:DATA.est5.chip, t:DATA.est5.titulo, p:DATA.est5.intro, cta:'Ir a por el impostor →' }
  ];
  function renderPortadaEstacion(){
    var p = PORTADAS[state.est];
    elContent.innerHTML = '<div class="mmw-anim mmw-cover">'+
      '<span class="mmw-chip">'+p.chip+'</span>'+
      '<h3 class="mmw-h3">'+p.t+'</h3>'+
      '<p class="mmw-intro">'+p.p+'</p>'+
      '<div class="mmw-actions" style="justify-content:center;"><button type="button" class="mmw-btn mmw-btn-accent" data-act="play">'+p.cta+'</button></div>'+
    '</div>';
    progreso();
  }
  /* --- Estación 1: verdadero / falso --- */
  function renderVF(){
    var it = DATA.est1.items[state.paso];
    elContent.innerHTML = '<div class="mmw-anim">'+
      cabecera(DATA.est1.chip, '', '')+
      '<p class="mmw-counter">Afirmación '+(state.paso+1)+' de '+DATA.est1.items.length+'</p>'+
      '<p class="mmw-q">«'+it.t+'»</p>'+
      '<div class="mmw-vf">'+
        '<button type="button" class="mmw-opt" data-act="vf" data-v="1"><span class="mmw-opt-lbl">✅ Verdadero</span><span class="mmw-opt-mark">✓</span></button>'+
        '<button type="button" class="mmw-opt" data-act="vf" data-v="0"><span class="mmw-opt-lbl">❌ Falso</span><span class="mmw-opt-mark">✓</span></button>'+
      '</div>'+ fbBox() + acciones() +
    '</div>';
    progreso();
  }
  function responderVF(btn, valor){
    var it = DATA.est1.items[state.paso];
    var botones = elContent.querySelectorAll('[data-act="vf"]');
    var ok = (valor === (it.v ? 1 : 0));
    for(var i=0;i<botones.length;i++){
      botones[i].disabled = true;
      var esCorrecta = (botones[i].getAttribute('data-v') === (it.v ? '1':'0'));
      if(esCorrecta){ botones[i].classList.add('mmw-ok'); botones[i].querySelector('.mmw-opt-mark').textContent='✓'; }
    }
    if(!ok){
      btn.classList.remove('mmw-ok');
      btn.classList.add('mmw-bad','mmw-shake');
      btn.querySelector('.mmw-opt-mark').textContent = '✕';
      fallo({ id:'vf'+state.paso, q:'¿Verdadero o falso? «'+it.t+'»', opts:['Verdadero','Falso'], c: it.v?0:1, fb:it.fb });
      pintarFb(false, 'No exactamente', it.fb);
    } else {
      acierto(true);
      pintarFb(true, '¡Correcto!', it.fb);
    }
    state.hechos++;
    progreso();
    botonSiguiente(state.paso < DATA.est1.items.length-1 ? 'Siguiente afirmación →' : 'Estación superada →');
  }
  /* --- Estación 2: emparejar --- */
  var empEstado = { resueltos:0, sel:-1 };
  function renderEmparejar(){
    empEstado.resueltos = 0; empEstado.sel = -1;
    var izq = barajar(DATA.est2.pares.map(function(_,i){ return i; }));
    var der = barajar(DATA.est2.pares.map(function(_,i){ return i; }));
    var ha = '', hb = '';
    for(var i=0;i<izq.length;i++){
      ha += '<button type="button" class="mmw-mbtn" data-act="ma" data-i="'+izq[i]+'">'+DATA.est2.pares[izq[i]].a+'</button>';
    }
    for(var j=0;j<der.length;j++){
      hb += '<button type="button" class="mmw-mbtn" data-act="mb" data-i="'+der[j]+'">'+DATA.est2.pares[der[j]].b+'</button>';
    }
    elContent.innerHTML = '<div class="mmw-anim">'+
      cabecera(DATA.est2.chip, '', '')+
      '<p class="mmw-hint">'+DATA.est2.hint+'</p>'+
      '<div class="mmw-match">'+
        '<div class="mmw-col"><p class="mmw-col-h">Concepto</p>'+ha+'</div>'+
        '<div class="mmw-col"><p class="mmw-col-h">Dato exacto</p>'+hb+'</div>'+
      '</div>'+ fbBox() + acciones() +
    '</div>';
    progreso();
  }
  function elegirIzq(btn){
    var previos = elContent.querySelectorAll('[data-act="ma"].mmw-sel');
    for(var i=0;i<previos.length;i++) previos[i].classList.remove('mmw-sel');
    var idx = parseInt(btn.getAttribute('data-i'),10);
    if(empEstado.sel === idx){ empEstado.sel = -1; return; }
    empEstado.sel = idx;
    btn.classList.add('mmw-sel');
  }
  function elegirDer(btn){
    if(empEstado.sel < 0){
      pintarFb(false, 'Empieza por la izquierda', 'Selecciona primero un concepto y después su dato exacto.');
      return;
    }
    var a = empEstado.sel, b = parseInt(btn.getAttribute('data-i'),10);
    var btnA = elContent.querySelector('[data-act="ma"][data-i="'+a+'"]');
    var par = DATA.est2.pares[a];
    if(a === b){
      acierto(true);
      btnA.classList.remove('mmw-sel'); btnA.classList.add('mmw-ok'); btnA.disabled = true;
      btn.classList.add('mmw-ok'); btn.disabled = true;
      pintarFb(true, par.a+' → correcto', par.b+'. '+par.fb);
      empEstado.resueltos++;
      state.hechos++;
      progreso();
      if(empEstado.resueltos >= DATA.est2.pares.length){
        pintarFb(true, '¡Todos los datos encontrados!', DATA.est2.cierre);
        botonSiguiente('Estación superada →');
      }
    } else {
      fallo({ id:'em'+a, q:'¿Cuál es el dato exacto de: «'+par.a+'»?',
              opts:[DATA.est2.pares[b].b, par.b], c:1, fb:par.b+'. '+par.fb });
      btnA.classList.add('mmw-shake');
      btn.classList.add('mmw-shake');
      pintarFb(false, 'Ese dato no es de '+par.a, 'El dato exacto de <strong>'+par.a+'</strong> es: '+par.b+'. '+par.fb);
      setTimeout(function(){
        btnA.classList.remove('mmw-shake','mmw-sel');
        btn.classList.remove('mmw-shake');
      }, 420);
      empEstado.sel = -1;
    }
  }
  /* --- Estación 3: ordenar secuencia --- */
  var ordEstado = { puestos:[], intentos:0, orden:[] };
  function renderOrdenar(){
    ordEstado.puestos = []; ordEstado.intentos = 0;
    var ronda = DATA.est3.rondas[state.paso];
    ordEstado.orden = barajar(ronda.pasos.map(function(_,i){ return i; }));
    elContent.innerHTML = '<div class="mmw-anim">'+
      cabecera(DATA.est3.chip, '', '')+
      '<p class="mmw-counter">Secuencia '+(state.paso+1)+' de '+DATA.est3.rondas.length+'</p>'+
      '<p class="mmw-q">'+ronda.pregunta+'</p>'+
      '<div class="mmw-seq" data-mmw="seq"></div>'+
      '<div class="mmw-seq-pool" data-mmw="pool"></div>'+
      fbBox() + acciones() +
    '</div>';
    pintarPool();
    progreso();
  }
  function pintarPool(){
    var ronda = DATA.est3.rondas[state.paso];
    var pool = q('pool');
    if(!pool) return;
    var html = '';
    for(var k=0;k<ordEstado.orden.length;k++){
      var idx = ordEstado.orden[k];
      if(ordEstado.puestos.indexOf(idx) !== -1) continue;
      html += '<button type="button" class="mmw-item" data-act="ordchip" data-i="'+idx+'">'+ronda.pasos[idx]+'</button>';
    }
    pool.innerHTML = html;
    pintarSecuencia();
  }
  function pintarSecuencia(){
    var ronda = DATA.est3.rondas[state.paso];
    var seq = q('seq');
    if(!seq) return;
    var html = '';
    for(var i=0;i<ordEstado.puestos.length;i++){
      html += '<div class="mmw-seq-slot"><span class="mmw-seq-num">'+(i+1)+'</span><span>'+ronda.pasos[ordEstado.puestos[i]]+'</span></div>';
    }
    seq.innerHTML = html;
    var acts = q('acts');
    if(acts){
      if(ordEstado.puestos.length >= ronda.pasos.length){
        acts.innerHTML = '<button type="button" class="mmw-btn mmw-btn-accent" data-act="comprobar">Comprobar orden →</button>';
      } else {
        acts.innerHTML = '';
      }
    }
  }
  function tocarChipOrden(btn){
    var idx = parseInt(btn.getAttribute('data-i'),10);
    if(ordEstado.puestos.indexOf(idx) !== -1) return;
    ordEstado.puestos.push(idx);
    pintarPool();
  }
  function comprobarOrden(){
    var ronda = DATA.est3.rondas[state.paso];
    var correcto = true;
    for(var i=0;i<ordEstado.puestos.length;i++){
      if(ordEstado.puestos[i] !== i){ correcto = false; break; }
    }
    var slots = elContent.querySelectorAll('.mmw-seq-slot');
    for(var s=0;s<slots.length;s++){
      slots[s].classList.add(ordEstado.puestos[s] === s ? 'mmw-ok' : 'mmw-bad');
    }
    if(correcto){
      acierto(ordEstado.intentos === 0);
      pintarFb(true, ordEstado.intentos === 0 ? '¡Orden correcto!' : 'Ahora sí', ronda.explicacion);
      state.hechos++;
      progreso();
      botonSiguiente(state.paso < DATA.est3.rondas.length-1 ? 'Siguiente secuencia →' : 'Estación superada →');
    } else {
      if(ordEstado.intentos === 0){
        var correctaArr = ronda.pasos;
        var reversa = correctaArr.slice().reverse();
        var swap = correctaArr.slice();
        if(swap.length >= 2){ var tmp = swap[0]; swap[0] = swap[1]; swap[1] = tmp; }
        var opciones = barajar([correctaArr.join(' → '), reversa.join(' → '), swap.join(' → ')]);
        var correctaTxt = correctaArr.join(' → ');
        var ci = 0;
        for(var o=0;o<opciones.length;o++){ if(opciones[o]===correctaTxt) ci=o; }
        fallo({ id:'ord'+state.paso, q:ronda.pregunta, opts:opciones, c:ci, fb:ronda.explicacion });
      }
      ordEstado.intentos++;
      pintarFb(false, 'Ese orden no es correcto', 'Fíjate en los pasos marcados en rojo y vuelve a intentarlo.');
      var acts = q('acts');
      if(acts) acts.innerHTML = '<button type="button" class="mmw-btn mmw-btn-ghost" data-act="reordenar">↻ Reordenar</button>';
    }
  }
  function reordenar(){
    ordEstado.puestos = [];
    pintarPool();
    var fb = q('fb');
    if(fb){ fb.className='mmw-fb'; fb.innerHTML=''; }
  }
  /* --- Estación 4: clasificar --- */
  var clasEstado = { colocados:0, sel:-1, orden:[] };
  function renderClasificar(){
    clasEstado.colocados = 0; clasEstado.sel = -1;
    clasEstado.orden = barajar(DATA.est4.items.map(function(_,i){ return i; }));
    var chips = '';
    for(var k=0;k<clasEstado.orden.length;k++){
      var idx = clasEstado.orden[k];
      chips += '<button type="button" class="mmw-item" draggable="true" data-act="chip" data-i="'+idx+'">'+DATA.est4.items[idx].t+'</button>';
    }
    var zonas = '';
    for(var z=0; z<DATA.est4.zonas.length; z++){
      zonas += '<div class="mmw-zone" data-zone="'+z+'" role="button" tabindex="0" aria-label="Soltar en: '+DATA.est4.zonas[z].label+'">'+
        '<p class="mmw-zone-h">'+DATA.est4.zonas[z].label+'</p>'+
        '<div class="mmw-zone-items" data-mmw="zi'+z+'"></div>'+
      '</div>';
    }
    elContent.innerHTML = '<div class="mmw-anim">'+
      cabecera(DATA.est4.chip, '', '')+
      '<p class="mmw-hint">'+DATA.est4.hint+'</p>'+
      '<div class="mmw-tray" data-mmw="tray">'+chips+'</div>'+
      '<div class="mmw-zones">'+zonas+'</div>'+
      fbBox() + acciones() +
    '</div>';
    progreso();
  }
  function seleccionarChip(btn){
    var previos = elContent.querySelectorAll('.mmw-item.mmw-sel');
    for(var i=0;i<previos.length;i++) previos[i].classList.remove('mmw-sel');
    if(clasEstado.sel === parseInt(btn.getAttribute('data-i'),10)){ clasEstado.sel = -1; return; }
    clasEstado.sel = parseInt(btn.getAttribute('data-i'),10);
    btn.classList.add('mmw-sel');
  }
  function soltarEnZona(zona){
    if(clasEstado.sel < 0) return;
    var i = clasEstado.sel;
    var item = DATA.est4.items[i];
    var chip = elContent.querySelector('[data-act="chip"][data-i="'+i+'"]');
    if(!chip) return;
    var ok = (item.z === zona);
    clasEstado.sel = -1;
    chip.classList.remove('mmw-sel');
    if(ok){
      acierto(true);
      pintarFb(true, item.t+' → correcto', item.fb);
    } else {
      chip.classList.add('mmw-shake');
      fallo({ id:'cl'+i, q:'<strong>'+item.t+'</strong>: ¿a qué fase del ciclo pertenece?',
              opts:[DATA.est4.zonas[0].label,DATA.est4.zonas[1].label,DATA.est4.zonas[2].label,DATA.est4.zonas[3].label], c:item.z, fb:item.fb });
      pintarFb(false, item.t+' → fase equivocada', item.fb);
    }
    chip.setAttribute('draggable','false');
    chip.disabled = true;
    chip.classList.add('mmw-placed', ok ? 'mmw-ok' : 'mmw-bad');
    chip.innerHTML = (ok ? '✓ ' : '↪ ') + item.t;
    var destino = q('zi'+item.z);
    if(destino) destino.appendChild(chip);
    clasEstado.colocados++;
    state.hechos++;
    progreso();
    if(clasEstado.colocados >= DATA.est4.items.length){
      var fb = q('fb');
      if(fb) fb.innerHTML += '<div class="mmw-pearl">🗂️ '+DATA.est4.cierre+'</div>';
      botonSiguiente('Estación superada →');
    }
  }
  /* --- Estación 5: caza al impostor --- */
  var impEstado = { intentos:0 };
  function renderImpostor(){
    impEstado.intentos = 0;
    var ronda = DATA.est5.rondas[state.paso];
    var letras = ['A','B','C','D'];
    var ops = '';
    for(var i=0;i<ronda.opts.length;i++){
      ops += '<button type="button" class="mmw-opt" data-act="imp" data-i="'+i+'">'+
        '<span class="mmw-opt-key">'+letras[i]+'</span>'+
        '<span class="mmw-opt-lbl">'+ronda.opts[i].t+'</span>'+
        '<span class="mmw-opt-mark">🕵️</span></button>';
    }
    elContent.innerHTML = '<div class="mmw-anim">'+
      cabecera(DATA.est5.chip, '', '')+
      '<p class="mmw-counter">Escenario '+(state.paso+1)+' de '+DATA.est5.rondas.length+'</p>'+
      '<p class="mmw-q">'+ronda.escenario+'</p>'+
      '<div class="mmw-opts">'+ops+'</div>'+
      fbBox() + acciones() +
    '</div>';
    progreso();
  }
  function responderImpostor(btn){
    var ronda = DATA.est5.rondas[state.paso];
    var i = parseInt(btn.getAttribute('data-i'),10);
    var op = ronda.opts[i];
    if(op.ok){
      var primera = (impEstado.intentos === 0);
      var botones = elContent.querySelectorAll('[data-act="imp"]');
      for(var k=0;k<botones.length;k++) botones[k].disabled = true;
      btn.classList.add('mmw-ok');
      btn.querySelector('.mmw-opt-mark').textContent = '✓';
      acierto(primera);
      pintarFb(true, primera ? '¡Impostor cazado!' : 'Ahora sí', op.fb);
      state.hechos++;
      progreso();
      botonSiguiente(state.paso < DATA.est5.rondas.length-1 ? 'Siguiente escenario →' : 'Estación superada →');
    } else {
      if(btn.classList.contains('mmw-bad')) return;
      impEstado.intentos++;
      btn.classList.add('mmw-bad','mmw-shake');
      btn.disabled = true;
      btn.querySelector('.mmw-opt-mark').textContent = '✕';
      setTimeout(function(){ btn.classList.remove('mmw-shake'); }, 420);
      if(impEstado.intentos === 1){
        var etiquetas = [], correcta = 0, fbCorrecta = '';
        for(var m=0;m<ronda.opts.length;m++){
          etiquetas.push(ronda.opts[m].t);
          if(ronda.opts[m].ok){ correcta = m; fbCorrecta = ronda.opts[m].fb; }
        }
        fallo({ id:'imp'+state.paso, q:ronda.escenario, opts:etiquetas, c:correcta, fb:fbCorrecta });
      }
      pintarFb(false, 'Esa opción sí encaja', 'Esa es una afirmación correcta en este escenario, no el impostor. Prueba con otra.');
    }
  }
  /* --- Modo repaso de fallos --- */
  function renderRepaso(){
    var p = state.repasoLista[state.repasoIdx];
    var ops = '';
    for(var i=0;i<p.opts.length;i++){
      ops += '<button type="button" class="mmw-opt" data-act="rep" data-i="'+i+'">'+
        '<span class="mmw-opt-key">'+String.fromCharCode(65+i)+'</span>'+
        '<span class="mmw-opt-lbl">'+p.opts[i]+'</span>'+
        '<span class="mmw-opt-mark">✓</span></button>';
    }
    elContent.innerHTML = '<div class="mmw-anim">'+
      '<span class="mmw-chip">🔁 Repaso de fallos</span>'+
      '<p class="mmw-counter">Pregunta '+(state.repasoIdx+1)+' de '+state.repasoLista.length+'</p>'+
      '<p class="mmw-q">'+p.q+'</p>'+
      '<div class="mmw-opts">'+ops+'</div>'+
      fbBox() + acciones() +
    '</div>';
    progreso();
  }
  function responderRepaso(btn){
    var p = state.repasoLista[state.repasoIdx];
    var i = parseInt(btn.getAttribute('data-i'),10);
    var botones = elContent.querySelectorAll('[data-act="rep"]');
    for(var k=0;k<botones.length;k++){
      botones[k].disabled = true;
      if(parseInt(botones[k].getAttribute('data-i'),10) === p.c){
        botones[k].classList.add('mmw-ok');
        botones[k].querySelector('.mmw-opt-mark').textContent = '✓';
      }
    }
    if(i === p.c){
      sumarPuntos(5);
      pintarFb(true, '¡Esta vez sí!', p.fb);
    } else {
      btn.classList.remove('mmw-ok');
      btn.classList.add('mmw-bad','mmw-shake');
      btn.querySelector('.mmw-opt-mark').textContent = '✕';
      pintarFb(false, 'Todavía se te resiste', p.fb);
    }
    botonSiguiente(state.repasoIdx < state.repasoLista.length-1 ? 'Siguiente →' : 'Terminar el repaso →');
  }
  /* =========================================================================
     6) MOTOR: navegación entre estaciones
     ========================================================================= */
  var RENDERS = [renderVF, renderEmparejar, renderOrdenar, renderClasificar, renderImpostor];
  var LARGOS  = [
    function(){ return DATA.est1.items.length; },
    function(){ return 1; },
    function(){ return DATA.est3.rondas.length; },
    function(){ return 1; },
    function(){ return DATA.est5.rondas.length; }
  ];
  function pintar(){
    if(state.vista === 'portadaEst') return renderPortadaEstacion();
    if(state.vista === 'repaso') return renderRepaso();
    if(state.vista === 'juego') return RENDERS[state.est]();
  }
  function siguiente(){
    if(state.vista === 'repaso'){
      if(state.repasoIdx < state.repasoLista.length-1){ state.repasoIdx++; renderRepaso(); }
      else { mostrarFinal(true); }
      irArriba();
      return;
    }
    state.paso++;
    if(state.paso >= LARGOS[state.est]()){
      state.est++;
      state.paso = 0;
      if(state.est >= N_ESTACIONES){ mostrarFinal(false); irArriba(); return; }
      state.vista = 'portadaEst';
      renderPortadaEstacion();
    } else {
      pintar();
    }
    irArriba();
  }
  function irArriba(){
    try{ elStage.scrollIntoView({behavior:'smooth', block:'nearest'}); }catch(e){}
  }
  function empezar(){
    elCover.classList.add('mmw-hidden');
    elEnd.classList.add('mmw-hidden');
    elContent.classList.remove('mmw-hidden');
    elHud.classList.remove('mmw-hidden');
    state.vista = 'portadaEst';
    state.est = 0; state.paso = 0;
    renderPortadaEstacion();
  }
  function reiniciar(){
    state.est=0; state.paso=0; state.hechos=0; state.puntos=0; state.racha=0; state.mejorRacha=0;
    state.limpios=0; state.fallos=0; state.falladas=[]; state.repaso=false; state.repasoIdx=0; state.repasoLista=[];
    if(elScore) elScore.textContent = '0';
    if(elStreak) elStreak.textContent = '0';
    elStage.classList.remove('mmw-mood-warn','mmw-mood-bad','mmw-mood-good');
    setBadge('🟢 Eje claro');
    if(elDesajuste) elDesajuste.textContent = '2/10';
    if(elDesajusteFill){ elDesajusteFill.setAttribute('width','8'); elDesajusteFill.setAttribute('fill','#3fa96a'); }
    if(elNeedle) elNeedle.setAttribute('transform','rotate(-72 75 105)');
    if(elReloj) elReloj.setAttribute('transform','rotate(0 214 90)');
    if(elConfetti){ elConfetti.classList.add('mmw-hidden'); elConfetti.innerHTML=''; }
    empezar();
  }
  function abrirRepaso(){
    if(!state.falladas.length) return;
    state.repaso = true;
    state.repasoIdx = 0;
    state.repasoLista = state.falladas.slice();
    state.vista = 'repaso';
    elEnd.classList.add('mmw-hidden');
    elContent.classList.remove('mmw-hidden');
    renderRepaso();
    irArriba();
  }
  /* =========================================================================
     7) PANTALLA FINAL
     ========================================================================= */
  function mostrarFinal(trasRepaso){
    state.vista = 'final';
    elContent.classList.add('mmw-hidden');
    elEnd.classList.remove('mmw-hidden');
    var pct = TOTAL ? Math.round((state.limpios/TOTAL)*100) : 0;
    var estrellas = pct >= 85 ? 3 : (pct >= 60 ? 2 : 1);
    var htmlEstrellas = '';
    for(var i=0;i<3;i++){
      htmlEstrellas += '<span class="mmw-star '+(i<estrellas ? 'mmw-on s'+(i+1) : '')+'">★</span>';
    }
    var mensaje = pct >= 85 ? 'Dominas el eje hormonal y las cuatro fases del ciclo con precisión.' :
                  (pct >= 60 ? 'Buen manejo general, pero algún matiz todavía te despista.' :
                   'Repasa sobre todo el sentido de la retroalimentación en la fase proliferativa y el efecto de la GnRH continua.');
    var recap = '';
    for(var r=0;r<DATA.resumen.length;r++){ recap += '<li>'+DATA.resumen[r]+'</li>'; }
    var botones = '';
    if(state.falladas.length && !trasRepaso){
      botones += '<button type="button" class="mmw-btn mmw-btn-accent" data-act="repaso">🔁 Repasar mis '+state.falladas.length+' fallo'+(state.falladas.length>1?'s':'')+'</button>';
    }
    botones += '<button type="button" class="mmw-btn '+(state.falladas.length && !trasRepaso ? 'mmw-btn-ghost' : 'mmw-btn-accent')+'" data-act="restart">↻ Volver a empezar</button>';
    elEnd.innerHTML = '<div class="mmw-anim">'+
      '<h3>'+(trasRepaso ? '🔁 Repaso terminado' : '🏁 Ciclo genital femenino dominado')+'</h3>'+
      '<div class="mmw-stars">'+htmlEstrellas+'</div>'+
      '<p class="mmw-score">'+mensaje+'<br>'+state.puntos+' puntos · '+state.limpios+'/'+TOTAL+' a la primera · mejor racha: '+state.mejorRacha+' 🔥</p>'+
      '<div class="mmw-recap"><h4>🧠 Tu chuleta de este tema</h4><ul>'+recap+'</ul></div>'+
      '<div class="mmw-actions" style="justify-content:center;">'+botones+'</div>'+
    '</div>';
    if(pct >= 80){
      elStage.classList.remove('mmw-mood-warn','mmw-mood-bad');
      elStage.classList.add('mmw-mood-good');
      setBadge('🎉 Ciclo dominado');
      confeti();
    }
    progreso();
  }
  function confeti(){
    if(!elConfetti) return;
    if(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    elConfetti.classList.remove('mmw-hidden');
    elConfetti.innerHTML = '';
    var colores = ['#306086','#d98c3f','#2f9e5c','#4cb877','#6a93b3','#f3d9b9'];
    for(var i=0;i<40;i++){
      var p = document.createElement('span');
      p.className = 'mmw-conf';
      p.style.left = ((i*2.5 + (i%5)*3) % 100) + '%';
      p.style.background = colores[i%colores.length];
      p.style.animationDuration = (2.4 + (i%6)*0.32).toFixed(2)+'s';
      p.style.animationDelay = ((i%9)*0.16).toFixed(2)+'s';
      if(i%3===0){ p.style.width='7px'; p.style.height='7px'; p.style.borderRadius='50%'; }
      elConfetti.appendChild(p);
    }
    setTimeout(function(){ elConfetti.classList.add('mmw-hidden'); elConfetti.innerHTML=''; }, 6200);
  }
  /* =========================================================================
     8) EVENTOS (delegación desde la raíz — sin funciones globales)
     ========================================================================= */
  root.addEventListener('click', function(ev){
    var btn = ev.target.closest ? ev.target.closest('[data-act]') : null;
    if(btn && root.contains(btn)){
      var act = btn.getAttribute('data-act');
      if(act === 'start'){ empezar(); return; }
      if(act === 'play'){ state.vista='juego'; pintar(); return; }
      if(act === 'next'){ siguiente(); return; }
      if(act === 'vf'){ responderVF(btn, parseInt(btn.getAttribute('data-v'),10)); return; }
      if(act === 'ma'){ elegirIzq(btn); return; }
      if(act === 'mb'){ elegirDer(btn); return; }
      if(act === 'ordchip'){ tocarChipOrden(btn); return; }
      if(act === 'comprobar'){ comprobarOrden(); return; }
      if(act === 'reordenar'){ reordenar(); return; }
      if(act === 'chip'){ seleccionarChip(btn); return; }
      if(act === 'imp'){ responderImpostor(btn); return; }
      if(act === 'rep'){ responderRepaso(btn); return; }
      if(act === 'repaso'){ abrirRepaso(); return; }
      if(act === 'restart'){ reiniciar(); return; }
    }
    var zona = ev.target.closest ? ev.target.closest('.mmw-zone') : null;
    if(zona && root.contains(zona)) soltarEnZona(parseInt(zona.getAttribute('data-zone'),10));
  });
  /* Teclado en las zonas de soltar (no son botones nativos) */
  root.addEventListener('keydown', function(ev){
    if(ev.key !== 'Enter' && ev.key !== ' ') return;
    var zona = ev.target.closest ? ev.target.closest('.mmw-zone') : null;
    if(zona && root.contains(zona)){
      ev.preventDefault();
      soltarEnZona(parseInt(zona.getAttribute('data-zone'),10));
    }
  });
  /* Arrastrar y soltar (con el clic como alternativa siempre disponible) */
  root.addEventListener('dragstart', function(ev){
    var chip = ev.target.closest ? ev.target.closest('[data-act="chip"]') : null;
    if(!chip) return;
    clasEstado.sel = parseInt(chip.getAttribute('data-i'),10);
    chip.classList.add('mmw-sel');
    if(ev.dataTransfer){
      ev.dataTransfer.effectAllowed = 'move';
      try{ ev.dataTransfer.setData('text/plain', chip.getAttribute('data-i')); }catch(e){}
    }
  });
  root.addEventListener('dragover', function(ev){
    var zona = ev.target.closest ? ev.target.closest('.mmw-zone') : null;
    if(!zona) return;
    ev.preventDefault();
    zona.classList.add('mmw-over');
  });
  root.addEventListener('dragleave', function(ev){
    var zona = ev.target.closest ? ev.target.closest('.mmw-zone') : null;
    if(zona) zona.classList.remove('mmw-over');
  });
  root.addEventListener('drop', function(ev){
    var zona = ev.target.closest ? ev.target.closest('.mmw-zone') : null;
    if(!zona) return;
    ev.preventDefault();
    zona.classList.remove('mmw-over');
    soltarEnZona(parseInt(zona.getAttribute('data-zone'),10));
  });
  progreso();
})();

/* ===================== CONTENEDOR / PESTAÑAS ===================== */
(function(){
  var root = document.getElementById('mmDemo');
  if(!root || root.getAttribute('data-mmdemo-ready') === '1') return;
  root.setAttribute('data-mmdemo-ready','1');

  var NOMBRES = ['Resumen activo','Claves MIR','Actividad'];
  var tabs   = [].slice.call(root.querySelectorAll('.mmdemo-tab'));
  var panels = [].slice.call(root.querySelectorAll('.mmdemo-panel'));
  var dots   = [].slice.call(root.querySelectorAll('.mmdemo-dot'));
  var ink    = document.getElementById('mmDemoInk');
  var stage  = document.getElementById('mmDemoStage');
  var prevBtn = document.getElementById('mmDemoPrev');
  var nextBtn = document.getElementById('mmDemoNext');
  var prevLbl = document.getElementById('mmDemoPrevLbl');
  var nextLbl = document.getElementById('mmDemoNextLbl');
  var actual = 0;

  /* ---- Indicador deslizante bajo la pestaña activa ---- */
  function moverInk(){
    var t = tabs[actual];
    if(!t || !ink) return;
    var contenedor = t.parentNode;
    var x = t.offsetLeft - contenedor.clientLeft;
    ink.style.width = t.offsetWidth + 'px';
    ink.style.transform = 'translateX(' + x + 'px)';
  }

  /* ---- Etiquetas de anterior / siguiente ---- */
  function pintarNav(){
    prevBtn.disabled = (actual === 0);
    nextBtn.disabled = (actual === tabs.length - 1);
    prevLbl.textContent = actual > 0 ? NOMBRES[actual - 1] : 'Anterior';
    nextLbl.textContent = actual < tabs.length - 1 ? NOMBRES[actual + 1] : 'Siguiente';
    for(var i=0;i<dots.length;i++){
      dots[i].classList.toggle('is-active', i === actual);
      dots[i].setAttribute('aria-current', i === actual ? 'true' : 'false');
    }
  }

  /* ---- Cambio de pestaña ---- */
  function ir(idx, conFoco){
    if(idx < 0 || idx >= tabs.length || idx === actual) return;
    var haciaDerecha = idx > actual;
    var anterior = actual;
    actual = idx;

    for(var i=0;i<tabs.length;i++){
      var activo = (i === idx);
      tabs[i].classList.toggle('is-active', activo);
      tabs[i].setAttribute('aria-selected', activo ? 'true' : 'false');
      tabs[i].setAttribute('tabindex', activo ? '0' : '-1');
    }
    panels[anterior].classList.remove('is-active','from-left','from-right');
    panels[idx].classList.remove('from-left','from-right');
    void panels[idx].offsetWidth;
    panels[idx].classList.add('is-active', haciaDerecha ? 'from-right' : 'from-left');

    moverInk();
    pintarNav();
    if(conFoco){ tabs[idx].focus(); }

    /* Si la parte alta del widget queda por encima de la pantalla, la traemos a la vista */
    var top = root.getBoundingClientRect().top;
    if(top < 0){
      try{ root.scrollIntoView({behavior:'smooth', block:'start'}); }
      catch(e){ root.scrollIntoView(); }
    }
  }

  /* ---- Eventos de pestañas, puntos y navegación ---- */
  root.addEventListener('click', function(ev){
    var t = ev.target.closest ? ev.target.closest('.mmdemo-tab') : null;
    if(t && root.contains(t)){ ir(parseInt(t.getAttribute('data-tab'),10)); return; }
    var d = ev.target.closest ? ev.target.closest('.mmdemo-dot') : null;
    if(d && root.contains(d)){ ir(parseInt(d.getAttribute('data-dot'),10)); return; }
    var n = ev.target.closest ? ev.target.closest('.mmdemo-navbtn') : null;
    if(n && root.contains(n)){ ir(actual + parseInt(n.getAttribute('data-nav'),10)); return; }
  });

  /* ---- Teclado sobre las pestañas ---- */
  root.addEventListener('keydown', function(ev){
    var t = ev.target.closest ? ev.target.closest('.mmdemo-tab') : null;
    if(!t || !root.contains(t)) return;
    if(ev.key === 'ArrowRight'){ ev.preventDefault(); ir(Math.min(actual+1, tabs.length-1), true); }
    else if(ev.key === 'ArrowLeft'){ ev.preventDefault(); ir(Math.max(actual-1, 0), true); }
    else if(ev.key === 'Home'){ ev.preventDefault(); ir(0, true); }
    else if(ev.key === 'End'){ ev.preventDefault(); ir(tabs.length-1, true); }
  });

  /* ---- Deslizar con el dedo (sin interferir con arrastrar y soltar) ---- */
  var x0 = null, y0 = null, bloqueado = false;
  stage.addEventListener('touchstart', function(ev){
    if(ev.touches.length !== 1){ x0 = null; return; }
    var t = ev.target;
    bloqueado = !!(t.closest && t.closest('[draggable="true"], .mmw-zone, .mmw-tray, .mm-assoc-card, summary, input, textarea, select'));
    x0 = ev.touches[0].clientX;
    y0 = ev.touches[0].clientY;
  }, {passive:true});
  stage.addEventListener('touchend', function(ev){
    if(x0 === null || bloqueado) { x0 = null; return; }
    var t = ev.changedTouches[0];
    var dx = t.clientX - x0, dy = t.clientY - y0;
    x0 = null;
    if(Math.abs(dx) < 65) return;
    if(Math.abs(dx) < Math.abs(dy) * 1.6) return;
    ir(dx < 0 ? actual + 1 : actual - 1);
  }, {passive:true});

  /* ---- "Ver el resumen completo" ---- */
  var clip = document.getElementById('mmDemoClip');
  var moreBtn = document.getElementById('mmDemoMoreBtn');
  if(clip && moreBtn){
    /* Si el resumen no llega al alto máximo, no hace falta el botón */
    setTimeout(function(){
      if(clip.scrollHeight <= clip.clientHeight + 8){
        clip.classList.add('is-open');
        moreBtn.parentNode.style.display = 'none';
      }
    }, 120);
    moreBtn.addEventListener('click', function(){
      var abierto = clip.classList.toggle('is-open');
      moreBtn.setAttribute('aria-expanded', abierto ? 'true' : 'false');
      moreBtn.textContent = abierto ? 'Contraer el resumen ↑' : 'Ver el resumen completo ↓';
      if(!abierto){
        var top = clip.getBoundingClientRect().top;
        if(top < 0){ try{ clip.scrollIntoView({behavior:'smooth', block:'start'}); }catch(e){} }
      }
    });
  }

  /* ---- Recolocar el indicador cuando cambie el tamaño o carguen las fuentes ---- */
  moverInk();
  pintarNav();
  window.addEventListener('resize', moverInk);
  window.addEventListener('load', moverInk);
  setTimeout(moverInk, 60);
  setTimeout(moverInk, 400);
  setTimeout(moverInk, 1200);
  if(document.fonts && document.fonts.ready && document.fonts.ready.then){
    document.fonts.ready.then(moverInk);
  }
  if(window.ResizeObserver){
    try{ new ResizeObserver(moverInk).observe(tabs[0].parentNode); }catch(e){}
  }
})();

  }
  if(document.readyState === 'loading'){
    document.addEventListener('DOMContentLoaded', mirmedicDemoArrancar);
  } else {
    mirmedicDemoArrancar();
  }
})();
